export default "__VITE_ASSET__BV8Fmctf__"